<template>
  <v-container class="p-2">
    <OverlayPageVue :showOverlay="loader" />
    <v-card flat>
      <v-row no-gutters>
        <v-col cols="2" class="m-auto">
          <img
            src="../../../../assets/master_logo.png"
            alt="QQPay"
            style="max-height: 80px; max-width: 160px"
          />
        </v-col>
        <v-col cols="4">
          <p class="font-weight-bold ma-0 pa-0">QQ Pay Sdn Bhd</p>
          <p class="ma-0 pa-0">
            Level 20, Menara 1 Sentrum, 201, Jalan Tun Sambanthan,
            <br />
            Brickfields,50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
          </p>
          <a href="https://www.qqpay.my/" target="_blank">www.qqpay.io</a>
        </v-col>
        <v-col cols="3">
          <p class="ma-0 pa-0">
            PIN NUMBER:<span class="font-weight-bold">
              {{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.pin_umber
              }}</span
            >
          </p>
          <p class="ma-0 pa-0">
            Transaction ID:<span class="font-weight-bold">
              {{ this.transactionDetails.txn_data.txn_id }}</span
            >
          </p>
          <p>
            Transaction Date: {{ this.transactionDetails.txn_data.txn_date }}
          </p>
          <p
            class="ma-0 pa-0"
            v-if="this.transactionDetails.txn_data.receiver_cpay_pinnumber"
          >
            Cash Pickup Pin Number:<span class="font-weight-bold">{{
              this.transactionDetails.txn_data.receiver_cpay_pinnumber
            }}</span>
          </p>
        </v-col>
        <v-col cols="2" class="mt-3">
          <div class="text-center">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="text-capitalize"
                  depressed
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  More Options
                  <v-icon class="ms-1" small>mdi-menu-down-outline</v-icon>
                </v-btn>
              </template>

              <v-card class="m-auto">
                <v-list class="d-flex ma-0 px-3">
                  <v-btn
                    link
                    @click="transactionReport()"
                    color="primary"
                    outlined
                    small
                    depressed
                  >
                    <v-list-item-title>
                      <v-icon small>mdi-printer </v-icon>
                      <span class="caption">Print Txn Report</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list>
                <!-- <v-list class="d-flex ma-0 px-3">
                  <v-btn
                    @click="cancelTransaction()"
                    color="primary"
                    outlined
                    small
                    depressed
                  >
                    <v-list-item-title>
                      <v-icon small>mdi-close </v-icon>
                      <span class="caption">Cancel Txn</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list> -->
                <!-- <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-cancel</v-icon>
                      <span class="caption">Block Txn</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list> -->
                <!-- <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-swap-horizontal</v-icon>
                      <span class="caption">Post to Un-Paid</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list> -->
                <!-- <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-information</v-icon>
                      <span class="caption">Settlement Details</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list> -->
                <!-- <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-file-pdf-box</v-icon>
                      <span class="caption">Export to PDF</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list>
                <v-list class="d-flex ma-0 px-3">
                  <v-btn color="primary" outlined small depressed>
                    <v-list-item-title>
                      <v-icon small>mdi-reload</v-icon>
                      <span class="caption">API log</span>
                    </v-list-item-title>
                  </v-btn>
                </v-list> -->
              </v-card>
            </v-menu>
          </div>
        </v-col>
      </v-row>
      <v-divider class="pa-0 m-auto" style="width: 95%"></v-divider>
      <v-simple-table style="width: 95%" class="m-auto mb-4 pa-2">
        <tr>
          <td colspan="12" class="primary pa-2 white--text font-weight-bold">
            Transaction Status:<span class="ms-2 font-weight-bold">{{
              this.transactionDetails.txn_data.txn_status
            }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            {{
              this.transactionDetails.txn_data &&
              this.transactionDetails.txn_data.sub_sending_partner
            }}
          </td>
          <td>Payout Partner</td>
          <td class="font-weight-bold">
            :
            {{
              this.transactionDetails.txn_data &&
              this.transactionDetails.txn_data.payout_partner
            }}
          </td>
        </tr>
        <tr>
          <td colspan="3">
            {{
              this.transactionDetails.txn_data &&
              this.transactionDetails.txn_data.sub_sending_branch
            }}
          </td>
          <td>Transaction Type</td>
          <td class="font-weight-bold">
            : {{ this.transactionDetails.txn_data.payment_mode }}
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <b>
              {{
                this.transactionDetails.txn_data &&
                this.transactionDetails.txn_data.sub_sending_country &&
                this.transactionDetails.txn_data.sub_sending_country.name
              }}</b
            >
          </td>
          <td>Operator Name</td>
          <td class="font-weight-bold">
            : {{ this.transactionDetails.txn_data.created_by }} -{{
              this.transactionDetails.txn_data.created_date
            }}
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
          <td>Approved By</td>
          <td class="font-weight-bold">
            : {{ this.transactionDetails.txn_data.is_approve_by }} -{{
              this.transactionDetails.txn_data.is_approve_date
            }}
          </td>
        </tr>
      </v-simple-table>

      <v-expansion-panels
        color="primary"
        style="width: 95%"
        class="m-auto"
        multiple
        dense
        focusable
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="font-weight-bold">Sender Information</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <senderinfo
              @senderdataUpdated="getTxnDetailsbyID"
              :senderInfo="transactionDetails.sender_data"
              :txn_status="transactionDetails.txn_data.txn_status"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="font-weight-bold">Receiver Information</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <reciever-info
              @RecieverDataUpdated="getTxnDetailsbyID"
              :recieverInfo="transactionDetails.receiver_data"
              :txn_status="transactionDetails.txn_data.txn_status"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="font-weight-bold">Transaction Information</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <transaction-info
              @TxnDataUpdated="getTxnDetailsbyID"
              :transactionInfo="transactionDetails.txn_data"
              :txn_status="transactionDetails.txn_data.txn_status"
              :user_type="transactionDetails.sender_data.user_type"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col cols="12" md="6" lg="6">
          <matched-info
            :CompliancematchingList="CompliancematchingList"
            :transactionDetails="transactionDetails"
          />
        </v-col>
        <v-col cols="12" md="6" lg="6" class="ms-0 mt-9 pe-4">
          <div class="me-4">
            <v-toolbar color="#ffeee1" flat dense>
              <span>Release Transaction</span>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-form ref="releaseForm" style="width: 95%" class="m-auto">
              <v-row class="px-2" row-gutters>
                <v-radio-group v-model="selectedtxnStatus" row>
                  <v-radio
                    label="Approve Transaction"
                    value="Success"
                  ></v-radio>
                  <v-radio label="Reject Transaction" value="Cancel"></v-radio>
                </v-radio-group>
              </v-row>
              <v-row class="mb-2">
                <v-col>
                  <v-select
                    class="rounded"
                    dense
                    outlined
                    hide-details
                    label="Transaction Remarks"
                    :items="
                      selectedtxnStatus === 'Success'
                        ? txnApprovedRemarks
                        : txnRejectedRemarks
                    "
                    :rules="validations.releaseRules"
                    v-model="selectedReleaseItem"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="remarks"
                    placeholder="Remarks"
                    dense
                    outlined
                    height="80px"
                    auto-grow
                    row-height="5"
                    :counter="counter"
                    :rules="[charLimit]"
                    ><template v-slot:v-counter="{ count, max }">
                      {{ count }}/{{ max }} characters entered,
                      {{ max - count }} remaining
                    </template></v-textarea
                  >
                </v-col>
              </v-row>
              <v-row no-gutters v-if="selectedtxnStatus === 'Success'">
                <v-col>
                  <v-checkbox
                    v-model="accept_txn"
                    label="I acknowledge that, this transaction is not made by Suspicious Customer.The names of the Sender/beneficiary didn't match those in the Sanction List."
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions>
                <v-row>
                  <v-col class="mb-4" v-if="selectedtxnStatus === 'Success'">
                    <span class="float-right">
                      <v-btn
                        depressed
                        color="primary"
                        class="text-capitalize ms-2"
                        small
                        :disabled="!accept_txn"
                        @click="updateTxnStatus()"
                      >
                        <v-icon small>mdi-check-circle</v-icon>Submit
                      </v-btn>
                    </span>
                  </v-col>
                  <v-col class="mb-4" v-else>
                    <span class="float-right">
                      <v-btn
                        depressed
                        color="primary"
                        class="text-capitalize ms-2"
                        small
                        :disabled="
                          !selectedReleaseItem &&
                          selectedtxnStatus === 'Reject Transaction'
                        "
                        @click="updateTxnStatus()"
                      >
                        <v-icon small>mdi-check-circle</v-icon>Submit
                      </v-btn>
                    </span>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-form>
          </div>
        </v-col>
      </v-row>

      <txn-comments
        :ref_number="transactionDetails.txn_data && transactionDetails.txn_data.pin_umber"
      />
    </v-card>
  </v-container>
</template>

<script>
import Senderinfo from "./TransactionDetails/Senderinfo.vue";
import RecieverInfo from "./TransactionDetails/RecieverInfo.vue";
import TransactionInfo from "./TransactionDetails/TransactionInfo.vue";
import MatchedInfo from "./TransactionDetails/MatchedInfo.vue";
import TxnComments from "@/components/compliance/Transactionhold/TransactionDetails/TxnComments.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import PaymentService from "@/services/PaymentService/paymentService.js";
import commonService from "@/services/CommonService/commonService.js";
import userService from "@/services/UserService/userService.js";
export default {
  name: "Suspicious Details",
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      loader: false,
      hints: true,
      transactionDetails: {},
      release_items: [],
      CompliancematchingList: [],
      counter: 200,
      charLimit: (v) => {
        if (v && v.length > 200) {
          return "Text must be 200 characters or less";
        } else if (!v) {
          return "Required";
        } else {
          return true;
        }
      },
      remarks: "",
      accept_txn: false,
      selectedReleaseItem: "",
      selectedtxnStatus: "Success",
      txnApprovedRemarks: [],
      txnRejectedRemarks: [],
      validations: {
        releaseRules: [(v) => !!v || "Required"],
        remarksRules: [(v) => !!v || "Rquired"],
      },
    };
  },
  mixins: [alerts],
  components: {
    TransactionInfo,
    RecieverInfo,
    Senderinfo,
    MatchedInfo,
    TxnComments,
    OverlayPageVue,
  },
  mounted() {
    console.log(this.$route.query.id);

    if (this.$route.query.id) {
      this.getTxnDetailsbyID();
      this.getCopmlianceMatching();
    }
    this.getTxnRemarksDropdown("CTAR");
    this.getTxnRemarksDropdown("CTRR");
  },
  methods: {
    transactionReport() {
      this.$router.push({
        path: "/TransactionReport",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    cancelTransaction() {
      this.$router.push({
        path: "/cancelTransaction",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    canceltransaction() {
      alert("transaction cancelled");
    },
    async getTxnRemarksDropdown(code) {
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          if (code === "CTAR") {
            this.txnApprovedRemarks = responseData.data.data.map((i) => {
              return i.value;
            });
          } else if (code == "CTRR") {
            this.txnRejectedRemarks = responseData.data.data.map((i) => {
              return i.value;
            });
          }
        }
        console.log("docs_LIST", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    // async getReleaseRemarks() {
    //   this.loader = true;
    //   try {
    //     const responseData = await CommonService.getRemarks();
    //     this.loader = false;
    //     if (responseData && responseData.data.status_code === 200) {
    //       this.release_items = responseData.data.data.map((i) => i.value);
    //     }
    //     //  else if (responseData.data.status_code === 401) {
    //     //   this.returnNewToken();
    //     //   this.getReleaseRemarks();
    //     // }
    //     else {
    //       this.showAlertError(`Failed: ${responseData.data.message}`);
    //     }
    //     console.log("Funds", responseData);
    //   } catch (e) {
    //     console.error(e);
    //     this.showAlertError("Something went wrong please try again later.");
    //     this.loader = false;
    //   }
    // },
    async updateTxnStatus() {
      let remarks;
      remarks =
        this.selectedReleaseItem == "Others"
          ? this.remarks
          : this.selectedReleaseItem;
      const customer_id = this.transactionDetails.sender_data.customer_id;
      const id = this.$route.query.id;
      const validate = this.$refs.releaseForm.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await PaymentService.updateTxn(
            id,
            customer_id,
            this.selectedtxnStatus,
            remarks
          );
          if (responseData && responseData.data.status_code === 200) {
            this.$router.push({
              path: "/suspiciousList",
            });

            this.loader = false;
            this.$refs.releaseForm.reset();
            this.showPopup = false;
            this.showAlertSuccess(responseData.data.message);
            console.log("taxes", responseData);
          } else {
            this.loader = false;
            this.showAlertError(`Failed: ${responseData.data.message}`);
          }
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }
    },
    async getTxnDetailsbyID() {
      this.loader = true;
      try {
        const responseData = await PaymentService.getTxnDetails(
          this.$route.query.id
        );
        if (responseData && responseData.data.status_code === 200) {
          this.loader = false;
          console.log(responseData.data);
          this.transactionDetails = { ...responseData.data.data[0] };
        } else {
          this.loader = false;
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("Funds", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async getCopmlianceMatching() {
      try {
        const responseData = await userService.getCopmlianceMatching(
          this.$route.query.pin_no
        );
        if (responseData && responseData.data.status_code === 200) {
          this.CompliancematchingList = responseData.data.data;
          console.log("data found", responseData);
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
// table,
// th,
// td {
//   border-bottom: 1px solid rgb(195, 195, 195);
//   border-collapse: collapse;
//   padding: 5px;
// }
.primary-bg {
  background-color: rgb(230, 228, 228);
}
</style>
